import api from '../utils/api';

class CacheApi {
  reset() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/cache-reset');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  }
}

const cacheApi = new CacheApi();
export default cacheApi;
